module.exports = __webpack_public_path__ + "img/imagefour.0008beba.jpg";